{
  "matrix_version": "2026-09-22",
  "status": "frozen",
  "validation_status": "pending-device-validation",
  "source": "PRD §10.1, D07",
  "notes": "Candidate coverage is a test taxonomy, not a support claim. Freeze before platform-specific flows; validate on real devices before beta. Feature detection cannot replace this policy.",
  "entries": [
    {
      "id": "desktop-chromium",
      "platform_id": "web-desktop-chromium",
      "os": ["windows", "macos", "linux"],
      "browser": ["chrome", "edge"],
      "storage": "indexeddb-opfs",
      "secure_key": "indexeddb-cryptokey",
      "share_url": true,
      "share_files": true,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["file_system_access", "download"],
      "camera": true,
      "contact_picker": false,
      "local_ai_adapter": "prompt-api",
      "fallbacks": ["copy_link", "qr", "download"]
    },
    {
      "id": "desktop-firefox",
      "platform_id": "web-desktop-firefox",
      "os": ["windows", "macos", "linux"],
      "browser": ["firefox"],
      "storage": "indexeddb-only",
      "secure_key": "indexeddb-cryptokey",
      "share_url": false,
      "share_files": false,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download"],
      "camera": true,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["copy_link", "qr", "download", "manual_field_placement"]
    },
    {
      "id": "macos-safari",
      "platform_id": "web-macos-safari",
      "os": ["macos"],
      "browser": ["safari"],
      "storage": "indexeddb-opfs",
      "secure_key": "indexeddb-cryptokey",
      "share_url": true,
      "share_files": false,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download", "files_picker"],
      "camera": true,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["copy_link", "download", "storage_risk_warning"]
    },
    {
      "id": "ios-safari",
      "platform_id": "web-ios-safari",
      "os": ["ios"],
      "browser": ["safari"],
      "storage": "indexeddb-opfs",
      "secure_key": "indexeddb-cryptokey",
      "share_url": true,
      "share_files": true,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download", "files_picker"],
      "camera": true,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["browser_only_signing", "typed_or_upload_signature", "copy_link"]
    },
    {
      "id": "ipad-safari-pwa",
      "platform_id": "web-ipad-safari-pwa",
      "os": ["ios"],
      "browser": ["safari"],
      "storage": "indexeddb-opfs",
      "secure_key": "indexeddb-cryptokey",
      "share_url": true,
      "share_files": false,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download", "files_picker"],
      "camera": true,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["manual_export_import", "copy_link"]
    },
    {
      "id": "android-chrome-pwa",
      "platform_id": "web-android-chrome-pwa",
      "os": ["android"],
      "browser": ["chrome"],
      "storage": "indexeddb-opfs",
      "secure_key": "indexeddb-cryptokey",
      "share_url": true,
      "share_files": true,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["file_system_access", "download"],
      "camera": true,
      "contact_picker": true,
      "local_ai_adapter": null,
      "fallbacks": ["copy_link", "download", "draft_checkpoint_recovery"]
    },
    {
      "id": "native-ios",
      "platform_id": "native-ios",
      "os": ["ios"],
      "browser": ["native"],
      "storage": "native-vault",
      "secure_key": "keychain",
      "share_url": true,
      "share_files": true,
      "purchase_provider": "apple",
      "decoders": ["pdf", "png", "jpeg", "heic"],
      "backup_adapters": ["files_picker", "provider_folder"],
      "camera": true,
      "contact_picker": true,
      "local_ai_adapter": "foundation-models",
      "fallbacks": ["manual_backup_to_files", "resume_foreground"]
    },
    {
      "id": "native-android",
      "platform_id": "native-android",
      "os": ["android"],
      "browser": ["native"],
      "storage": "native-vault",
      "secure_key": "keystore",
      "share_url": true,
      "share_files": true,
      "purchase_provider": "google_play",
      "decoders": ["pdf", "png", "jpeg", "heic"],
      "backup_adapters": ["saf", "provider_folder"],
      "camera": true,
      "contact_picker": true,
      "local_ai_adapter": "gemini-nano-mlkit",
      "fallbacks": ["copy_imported_bytes_to_vault", "resume_foreground"]
    },
    {
      "id": "in-app-browser",
      "platform_id": "web-in-app-browser",
      "os": ["android", "ios", "macos", "windows", "linux"],
      "browser": ["in-app"],
      "storage": "indexeddb-only",
      "secure_key": "indexeddb-cryptokey",
      "share_url": false,
      "share_files": false,
      "purchase_provider": "unavailable",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download"],
      "camera": false,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["open_in_supported_browser_without_token_leak"]
    },
    {
      "id": "web-unknown",
      "platform_id": "web-unknown",
      "os": ["unknown"],
      "browser": ["unknown"],
      "storage": "indexeddb-only",
      "secure_key": "indexeddb-cryptokey",
      "share_url": false,
      "share_files": false,
      "purchase_provider": "stripe",
      "decoders": ["pdf", "png", "jpeg"],
      "backup_adapters": ["download"],
      "camera": false,
      "contact_picker": false,
      "local_ai_adapter": null,
      "fallbacks": ["copy_link", "download", "manual_field_placement"]
    }
  ]
}
